import { css, jsx } from '@emotion/react';
import { Animation, Icon } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('Arrow', {
    root: css({
        opacity: 0,
        height: 16,
        marginLeft: 0,
        marginTop: 2,
        position: 'absolute',
        transition: `opacity 100ms ${Animation.transitionTimingFunction}, margin 150ms ${Animation.transitionTimingFunction}`,
    }),
});
export const ArrowLinkIcon = () => (jsx("span", { css: Styles.root, "data-tag": "arrow-icon-wrapper", "data-zds": true },
    jsx(Icon, { name: "arrowBigRight", size: 14 })));
//# sourceMappingURL=ArrowLinkIcon.js.map
// @zapier/universal-layout@9.14.0 (b13df7b0f)
